import { EVENTS, GetEmitArgs, GetOnFunction } from './event';
export default class EventBus {
  eventList: {
    [key: string]: Set<Function>;
  };

  constructor() {
    this.eventList = {};
  }

  $on<T extends EVENTS>(event: T, fn: GetOnFunction<T>) {
    if (!this.eventList[event]) {
      this.eventList[event] = new Set<Function>();
    }

    this.eventList[event].add(fn);
    return {
      stop: () => {
        this.eventList[event].delete(fn);
      }
    };
  }

  $emit<T extends EVENTS>(event: T, args?: GetEmitArgs<T>) {
    this.eventList[event] && this.eventList[event].forEach(fn => {
      fn(args || {});
    });
  }

}